module.exports = __webpack_public_path__ + "static/durazno1-eb6f281ad20ac64e0ef92a31dd35b40c.jpg";